import React, {createContext, useContext, useEffect, useState} from 'react'
import {useErrorHandling} from 'context/errorHandling'
import {fetchMetrics} from "../services";

const GlobalDataContext = createContext({
  metrics: {},
})

export const GlobalDataProvider = ({children}) => {
  const [metrics, setMetrics] = useState(null)
  const [count, setCount] = useState(0)

  const {handleError} = useErrorHandling()

  useEffect(() => {
    fetchMetrics()
      .then(setMetrics)
      .catch(handleError)
      .finally(() =>
        setTimeout(() => {
          setCount(count + 1)
        }, 30000)
      )
  }, [count, setMetrics, handleError])

  return <GlobalDataContext.Provider value={{
    metrics,
  }}>
    {children}
  </GlobalDataContext.Provider>
}

export function useGlobalData() {
  return useContext(GlobalDataContext)
}
